import { LanguageCodesEnum } from '@/interfaces/languages.interface'

export interface TopicTranslation {
  description: string
  ta_link: string
  title: string
  privacy_policy_link?: string
  rating_button_title?: string
  rating_star_title?: string
}

export interface Topic {
  description: string
  id: number
  original_id: number // Same as id for regular topics, id of the original topic for custom
  photo: string
  photo_name: string
  subcategory_id: number
  ta_link: string
  title: string
  video: string
  website: string
  google_place?: google.maps.places.PlaceResult
  translations: Partial<Record<LanguageCodesEnum, TopicTranslation>>
  isWeatherWidget?: boolean
  custom_location?: {
    lat: number
    lng: number
  }
  dynamic_content_type: TopicContentTypeEnum
  is_phone_required?: string
  is_email_required?: string
  is_for_marketing?: boolean
}

export interface Subcategory {
  category_id: number
  expand_topics: boolean
  id: number
  title: string
  title_translations: Partial<Record<LanguageCodesEnum, string>>
  topics: Topic[]
}

export interface Category {
  icon: string
  id: number
  title: string
  title_translations: Partial<Record<LanguageCodesEnum, string>>
  subcategories: Subcategory[]
}

export enum TabEnum {
  INFO = 'info',
  GUIDE = 'guide'
}

export enum TopicContentTypeEnum {
  REGULAR = 'regular', // default
  RATING = 'rating',
  FIRST_IMPRESSIONS = 'first_impressions',
  EMAIL_CAPTURE = 'email_capture',
  WEATHER = 'weather',
  LOCK_CODE = 'lockcode',
  RESERVATION = 'reservation',
  TIDE = 'tide'
}

export enum ShareTypesEnum {
  GUIDE = 'guide',
  CATEGORY = 'category',
  SUBCATEGORY = 'subcategory',
  TOPIC = 'topic'
}
